import Text, { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import Icon from "shared/components/utils/Icon";
import { COLOR_VALUES } from "shared/config/colors";
import { css } from "styled-components";
import styled from "styled-components/macro";

const areaDisabled = `&[aria-disabled="true"] {
    color: ${COLOR_VALUES.Gray_2};
}`;

export const InputLabel = styled.label`
    word-break: break-all;
    color: ${COLOR_VALUES.Gray_1};
    ${TEXT_VARIANT_STYLES.Headline_5}
    ${areaDisabled}
    margin: 0;

    ${(props) =>
        props.isDisabled &&
        css`
            pointer-events: none;
            user-select: none;
        `}
`;

export const FeedbackIcon = styled(Icon)`
    flex-shrink: 0;
`;

export const FormInputWrapperText = styled(Text)`
    word-break: break-all;
    ${areaDisabled}
`;
